import type { JSX } from 'react'

import { MessageTagLabels, MessageTagType } from 'common/builder/constants/facebookMessaging'
import { NotificationReason } from 'shared/api/common/schemas/notificationReason'

export enum OptionType {
  TAG = 'TAG',
  TOPIC = 'TOPIC',
}

interface TagOptionValue {
  id: MessageTagType
  propName: 'messageTag'
  optionType: OptionType.TAG
}

export interface TopicOptionValue extends NotificationReason {
  optionType: OptionType.TOPIC
}

export interface CommonOption<T> {
  label: string
  value: T
}

export type Option = CommonOption<TagOptionValue | TopicOptionValue>

export interface OptionsGroup {
  label: string
  value: string
  options: Option[]
  emptyLabel?: string | (() => JSX.Element)
}

export const TAGS_OPTIONS: CommonOption<TagOptionValue>[] = [
  MessageTagType.POST_PURCHASE_UPDATE,
  MessageTagType.CONFIRMED_EVENT_UPDATE,
  MessageTagType.ACCOUNT_UPDATE,
].map((id) => ({
  label: MessageTagLabels[id](),
  value: { id, propName: 'messageTag', optionType: OptionType.TAG },
}))
